import axios from 'axios';

// ─── Axios instance ───────────────────────────────────────────
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:3001/api',
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Request interceptor — attach Bearer token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('inventapro_token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor — normalize errors + handle 401
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('inventapro_token');
      localStorage.removeItem('inventapro_user');
      window.location.href = '/login';
    }
    const message =
      error.response?.data?.error ||
      error.response?.data?.message ||
      error.message ||
      'Error de conexión con el servidor';
    error.displayMessage = message;
    return Promise.reject(error);
  }
);

// ─── Auth ──────────────────────────────────────────────────────
export const authService = {
  login: (usuario, password) => api.post('/auth/login', { usuario, password }),
  me: () => api.get('/auth/me')
};

// ─── Usuarios ─────────────────────────────────────────────────
export const usuariosService = {
  getAll: () => api.get('/usuarios'),
  getById: (id) => api.get(`/usuarios/${id}`),
  create: (data) => api.post('/usuarios', data),
  update: (id, data) => api.put(`/usuarios/${id}`, data),
  delete: (id) => api.delete(`/usuarios/${id}`)
};

// ─── Auditoría ────────────────────────────────────────────────
export const auditoriaService = {
  getAll: (params = {}) => api.get('/auditoria', { params })
};

// ─── Productos ────────────────────────────────────────────────
export const productosService = {
  getAll: (params = {}) => api.get('/productos', { params }),
  getById: (id) => api.get(`/productos/${id}`),
  create: (data) => api.post('/productos', data),
  update: (id, data) => api.put(`/productos/${id}`, data),
  delete: (id) => api.delete(`/productos/${id}`)
};

// ─── Movimientos ──────────────────────────────────────────────
export const movimientosService = {
  getAll: (params = {}) => api.get('/movimientos', { params }),
  getById: (id) => api.get(`/movimientos/${id}`),
  create: (data) => api.post('/movimientos', data),
  getByProducto: (producto_id) => api.get('/movimientos', { params: { producto_id } })
};

// ─── Categorías ───────────────────────────────────────────────
export const categoriasService = {
  getAll: () => api.get('/categorias'),
  getById: (id) => api.get(`/categorias/${id}`),
  create: (data) => api.post('/categorias', data),
  update: (id, data) => api.put(`/categorias/${id}`, data),
  delete: (id) => api.delete(`/categorias/${id}`)
};

// ─── Dashboard ────────────────────────────────────────────────
export const dashboardService = {
  getKPIs: () => api.get('/dashboard'),
  getKPIsCategorias: () => api.get('/dashboard/categorias')
};

export default api;
